export default __webpack_public_path__ + "static/media/registerCollective.12118bc8.png";